// extracted by mini-css-extract-plugin
export var title = "contact-module--title--Mkl4i";
export var text = "contact-module--text--kE6hz";
export var promotion = "contact-module--promotion--wUWn_";
export var form = "contact-module--form--1Vjy9";
export var formControls = "contact-module--form-controls--2MhTG";
export var button = "contact-module--button--2NiwG";
export var formMessage = "contact-module--form-message--17Kah";